import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import CyberSecurity from '../../../../../../apis/cyberSecurityData';
import { setActiveBoard } from '../../../../../../actions/Dashboard/boardsActions';

const options = [
    { value: 'member', label: 'member' },
    { value: 'admin', label: 'admin' }
]


const EditMembersRole = () => {
    //redux store state
    const activeBoard = useSelector(state => state.dashboard_Boards.activeBoard);
    const currentUser = useSelector(state => state.currentUser);
    const accessToken = useSelector(state => state.accessToken);
    const dispatch = useDispatch();

    const onRoleChange = async (member, newRole) => {
        const newMembersArray = activeBoard.members.map(el => {
            if (el.userId === member._id) return { ...el, role: newRole };
            else return el
        })

        const response = await CyberSecurity.post('/editboardmembers', { boardId: activeBoard._id, newMembersArray }, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        })
        dispatch(setActiveBoard(response.data))
    }

    return (
        <ul className="my-boards-list pt-0">
            {activeBoard.membersData.map(member => {
                return (
                    <Row key={member._id}>
                        <Col>
                            <li className="d-flex align-items-between" >
                                <span className="d-flex align-items-center">
                                    <span className="my-boards-filter-avatar"><img className="img-fluid" src={member.image} alt="avatar" /></span>{member.firstName} {member.lastName}
                                </span>
                            </li>
                        </Col>
                        <Col>
                            {activeBoard && <Select placeholder={activeBoard.members.filter(el => el.userId === member._id)[0].role} options={options} onChange={(option) => onRoleChange(member, option.value)} />}
                        </Col>
                    </Row>
                )
            })}
        </ul>
    )
}

export default EditMembersRole
